import CircularProgress from '@mui/material/CircularProgress';
import React, { CSSProperties } from 'react';

const Loader: React.FC<{ style?: CSSProperties }> = ({ style }): React.JSX.Element => {
    return (
        <div data-testid="loader" style={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress
                size={120}
                sx={{
                    color: 'secondary',
                }}
                style={{
                    position: 'absolute',
                    top: '40%',
                    ...style,
                }}
            />
        </div>
    );
};

export default Loader;
